import { DateTime } from 'luxon';
import Tip from './v1/Tip';
import { Text, TextProps } from 'theme-ui';
import { ReactNode } from 'react';

export interface DateTimeDisplayProps extends TextProps {
  value: DateTime | string;
  format: Intl.DateTimeFormatOptions,
  nullValue?: ReactNode;
  tipFormat?: Intl.DateTimeFormatOptions
};

export default function DateTimeDisplay({
  value,
  format,
  nullValue = null,
  tipFormat = DateTime.DATETIME_FULL_WITH_SECONDS,
  ...props
}) {
  if (!value) {
    return nullValue;
  }
  const date = DateTime.isDateTime(value) ? value : DateTime.fromISO(value)
  return (
    <Tip
      content={date.toLocaleString(tipFormat)}
    >
      <Text
        {...props}
      >
        {date.toLocaleString(format)}
      </Text>
    </Tip>
  );
}
